import { FC } from "react"
import {themeStore, LongShortStatistics, LowerInfoProps} from "@root/common"
import { LowerInfoStyled } from "./LowerInfo.styled"
import { observer } from "mobx-react-lite"
import Row from "./Row/Row"


interface ILowerInfo {
    statistics?: LongShortStatistics
}

const LowerInfo: FC<LowerInfoProps> = observer((props) => {
    const {statistics} = props as ILowerInfo
    return (
        <LowerInfoStyled>
            {statistics && [statistics.long, statistics.short]?.map((longShort, i) =>
                <div key={i}>
                    <div className="headers">
                        <h3 style={{ color: themeStore.textColor }}>Цена</h3>
                        <h3 style={{ color: themeStore.textColor }}>Объем $</h3>
                    </div>

                    {[...(longShort.orderbook?.asks || [])]?.reverse()?.map((ask, i) =>
                        <Row 
                            key={Math.random()}
                            price={ask.price} 
                            volume={ask.volume} 
                            color={themeStore.redColor} 
                            width={100 * parseInt(ask.volume) / Math.max(...(longShort.orderbook?.asks?.map(ask => parseInt(ask.volume)) || []))}
                        />
                    )}

                    {longShort.orderbook?.bids?.map((bid, i) =>
                        <Row 
                            key={Math.random()}
                            price={bid.price} 
                            volume={bid.volume} 
                            color={themeStore.greenColor} 
                            width={100 * parseInt(bid.volume) / Math.max(...(longShort.orderbook?.bids?.map(bid => parseInt(bid.volume)) || []))}
                        />
                    )}
                </div>
            )}
        </LowerInfoStyled>
    )
})

export default LowerInfo